const messages = {
    buttons: {
        productBrochures: "Objaviť",
    },
    index: {
        title: "INFORMÁCIE O PRODUKTE",
        description: "Stiahnite si tu najnovšie brožúry a letáky našich pneumatík Bridgestone a Firestone.",
        categories: {
            productBrochures: {
                title: "Produktové brožúry",
                description: "Brožúry radov pneumatík Bridgestone a Firestone",
            },
            bDrive: {
              title: "Obrázky produktov",
              description: "Aktuálne obrázky nájdete na stiahnutie v našom portáli B-DRIVE.",
            },
        
          kickback: {
            description: "Den teilnehmenden Unternehmen werden Kickback-Gebühren auf Basis der übermittelten Umsatzzahlen gutgeschrieben.",
          },}
    }
};

export default {
    messages,
};

